import type { Page } from '@scalar-org/entities/project'
import type {
  HeadingRecord,
  StaticDoc,
  StaticDocError,
} from '@scalar-org/entities/publish'
import { htmlFromMarkdown } from '@scalar-org/guide-render/markdown'

/** Render markdown documents into HTML content */
export async function renderMarkdownContent(
  page: Page,
  markdown: string,
): Promise<StaticDoc | StaticDocError> {
  // Headings will be populated by the htmlFromMarkdown function
  const headings: Record<string, HeadingRecord> = {}
  return {
    html: `<div class="page-node">${await htmlFromMarkdown({
      md: markdown,
      pageTitle: page.title,
      pageDescription: page.description,
      headings,
    })}</div>`,
    markdown,
    headings,
    error: false,
  }
}
